<template>
  <div class="order-wrap">

    <div class="order-list-wrap">
      <div class="order-card">
        <div class="order-tab">
          <div class="tabs">
            <template v-for="item in statusList">
              <div v-if="item.name != '已取消'" :key="item.status" @click="changeTab(item.status)"
                :class="['item', { 'active': listQuery.status === item.status }]">{{ item.name }}<span class="num">{{
              item.count || 0 }}</span></div>
            </template>
          </div>
          <div class="order-manager" @click="handleOrderManage"
            v-if="['project', 'service', 'store'].includes(listQuery.group)">
            {{ showOrderManage ? '取消管理' : '订单管理' }}
          </div>
        </div>
        <div class="order-content-wrap">
          <div class="search-bar">
            <div class="search-inp-wrap" v-if="!showOrderManage">
              <el-input placeholder="请输入关键词" style="width: 400px;" v-model="listQuery.keyword" clearable
                @clear="handleFilter" @keyup.enter.native="handleFilter">
                <el-select v-model="listQuery.keyword_type" style="width: 120px;" slot="prepend" placeholder="请选择">
                  <el-option label="订单号" value="order_no">订单号</el-option>
                  <el-option label="项目名称" value="product_name">项目名称</el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
              </el-input>
            </div>
            <div v-else class="data-type-wrap">
              <div class="item" v-if="['project', 'service'].includes(listQuery.group)"
                :class="{ 'active': listQuery.is_draft == 1 }" @click="handleChangeOrderManage(1, null)">
                草稿箱</div>
              <div class="item" :class="{ 'active': listQuery.status == 100 }" @click="handleChangeOrderManage(0, 100)">
                回收站</div>
            </div>
            <!-- <div class="page-operate">
              <div class="page-btn" @click="handlePrevPage()">上一页</div>
              <div class="page-btn" @click="handleNextPage()">下一页</div>
            </div> -->
          </div>

          <div class="table-wrap" v-if="list">
            <el-table class="xm-table" :data="list" v-loading="loading" element-loading-text="给我一点时间"
              :empty-text="emptyText" fit highlight-current-row>
              <el-table-column label="订单信息" align="center" minWidth="400">
                <template slot-scope="{row}">
                  <div class="row01 flex-row">
                    <span class="flex-grow-1 mgl10 tal">订单号：{{ row.order_no }} </span>
                    <span class="flex-grow-0">时间：{{ row.create_time }}</span>
                  </div>
                  <div class="row002" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <div class="flex-col goods" v-for="(goods, index) in row.product" :key="index">
                      <div class="flex-row mgt10 mgl10 tal">
                        <div class="flex-grow-0 mgr10">
                          <el-image style="width: 70px;height: 70px;" :src="goods.cover"></el-image>
                        </div>
                        <div class="flex-grow-1 flex-col">
                          <div class="name flex-row">
                            <div class="flex-grow-1">{{ goods.name }}</div>
                            <div class="flex-grow-0 mgr10" v-if="row.team_id">
                              <el-tooltip class="item" effect="dark" :content="row.team_name" placement="top">
                                <span class="colorBlue">团队订单</span>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="desc">
                            <span>×{{ goods.num }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="金额" align="center" width="150">
                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <template v-if="row.integral_amount > 0">
                      <span> 实付：{{ row.integral_amount }}积分</span>
                    </template>
                    <template v-else>
                      <span v-if="row.order_amount > 0"> 总额：￥{{ row.order_amount }}</span>
                      <span v-if="row.pay_amount > 0"> 实付：￥{{ row.pay_amount }}</span>
                      <span v-if="row.coupon_amount > 0" class="colorRed"> 优惠券：￥{{ row.coupon_amount }}</span>
                    </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" width="100">
                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <span style="color:#FF8F1F;">{{ row.status_name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" width="120">
                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <span>{{ row.remark }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100" fixed="right">
                <template slot-scope="{row}">
                  <div class="row01">
                  </div>
                  <div class="row02 flex-xy-center flex-col"
                    :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                    <template v-if="row.is_draft">
                      <el-link :underline="false" @click="handleAddOrder(row)">去下单</el-link>
                    </template>
                    <template v-else>
                      <el-link v-if="row.status == 10" :underline="false" @click="handlePay(row)">立即支付</el-link>
                      <el-link v-if="[5, 10, 15, 20, 30].includes(row.status)" :underline="false"
                        @click="handleCancel(row)">取消</el-link>
                      <el-link v-if="[21].includes(row.status)" :underline="false"
                        @click="handleExpress(row)">去寄样</el-link>
                      <el-link v-if="[25].includes(row.status)" :underline="false"
                        @click="handleSure(row)">确认结果</el-link>
                      <el-link :underline="false" @click="handleDetail(row)">查看详情</el-link>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <img src="~@/assets/images/order_empty.png" class="empty-tip" alt="">
          </div>
          <div class="flex-row mgt20">
            <div class="flex-grow-1"></div>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 去寄样 -->
    <set-express :visible.sync="showSetExpressForm" :orderId="orderId" @getList="getList" />
  </div>
</template>

<script>
import { getOrderList, getOrderStatusStat, cancelOrder, setSure } from "@/api/order";
import waves from '@/directive/waves' // 水波纹指令
import clipboard from '@/directive/clipboard' // 复制指令
import SetExpress from './components/setExpress'
export default {
  name: "OrderList",
  components: {
    SetExpress
  },
  directives: {
    waves,
    clipboard
  },
  props: {},
  data() {
    return {
      loading: false,
      emptyText: '暂无数据',
      listQuery: {
        status: '',
        keyword: null,
        keyword_type: 'order_no',
        is_draft: 0,
        group: '',
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      tableRowHeight: 90,
      statusList: [],
      showOrderManage: false,
      showSetExpressForm: false,
      oldOrder: {},
      orderId: 0
    }

  },
  watch: {},
  created() {
    console.log(this.$route.params.group);
    this.listQuery.group = this.$route.params.group;
    this.getList();
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice;
    this.parseTime = this.utils.parseTime;
  },
  methods: {
    handleChangeOrderManage(is_draft, status) {
      this.listQuery.is_draft = is_draft;
      this.listQuery.status = status;
      this.handleFilter();
    },
    handleOrderManage() {
      this.showOrderManage = !this.showOrderManage;
      if (this.showOrderManage && ['project', 'service'].includes(this.listQuery.group)) {
        this.handleChangeOrderManage(1, null);
      } else {
        this.handleChangeOrderManage(0, 100);
      }
    },
    changeTab(status) {
      this.listQuery.status = status

      this.getList()
    },
    // 获取订单状态列表
    getOrderStatusStat() {
      const _listQuery = Object.assign({}, this.listQuery);
      getOrderStatusStat(_listQuery)
        .then((response) => {
          this.statusList = response.data;
        }).catch(() => {

        });
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getOrderList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
          this.getOrderStatusStat();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleExpress(row) {
      this.orderId = row.id
      this.showSetExpressForm = true;
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 上一页
    handlePrevPage() {
      let page = this.listQuery.page;
      if (page - 1 > 1) {
        page--
      }
      this.listQuery.page = page;
      this.getList();
    },
    // 下一页
    handleNextPage() {
      let page = this.listQuery.page;
      if ((this.total / this.listQuery.pagesize) > page + 1) {
        page++
      }
      this.listQuery.page = page;
      this.getList();
    },
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    // 取消订单
    handleCancel(order) {
      this.$confirm('确定要取消订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        cancelOrder({
          id: order.id
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message({
            type: 'success',
            message: '取消成功!'
          });
        })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 确认订单
    handleSure(order) {
      this.$confirm('确定确认订单结果吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setSure({
          id: order.id
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message({
            type: 'success',
            message: '确认成功!'
          });
        })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 去支付
    handlePay(order) {
      this.$router.push({
        path: '/cashier',
        query: {
          order_id: order.id,
          type: 0,
        }
      });
    },
    // 查看详情
    handleDetail(order) {
      this.$router.push({
        path: '/user/order/detail',
        query: {
          id: order.id
        }
      });
    },
    handleAddOrder(order) {
      if (order.product.length == 0) {
        this.$message.error('订单信息有误');
        return;
      }
      this.$router.push({
        path: '/order/add',
        query: {
          id: order.product[0].product_id,
          draft_id: order.id
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.order-wrap {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;

  .table-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    align-items: center;
    padding: 10px 0 0 0;

    .table {
      border: 1px solid #DCE5EB;
    }

    th {
      text-align: center;
      padding: 13px 0;
    }

    thead {
      tr {
        th {
          background-color: #E9F3F6;
        }

        th:nth-child(1) {
          font-size: 16px;
          font-weight: 400;
          color: #222222;

          i {
            color: #6F7F84;
          }
        }

        th:nth-child(2),
        th:nth-child(3),
        th:nth-child(4) {
          width: 120px;
        }

        th:nth-child(5) {
          width: 170px;
        }
      }
    }

    tbody {
      .name-th {
        width: 100%;
        display: flex;
        align-items: center;
        column-gap: 10px;
        padding-left: 30px;
        box-sizing: border-box;

        &>img {
          width: 75px;
          height: 75px;
        }
      }

      .pay-btn {
        width: 90px;
        height: 30px;
        background: #00B4E8;
        border-radius: 15px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto;
      }

      .download-btn {
        width: 90px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 15px;
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        margin: 0 auto;
        border: solid 1px #00B4E8;
      }

      tr {
        th {
          p {
            margin: 5px 0;
            cursor: pointer;
          }
        }
      }

      th:not(:last-child) {
        border-right: 1px solid #DCE5EB;
      }

      tr:not(:last-child) {
        border-bottom: 1px solid #DCE5EB;
      }

      &>.empty {
        position: relative;
        height: 43px;

        &>th {
          position: absolute;
          width: 100%;
          height: 43px;
          font-size: 15px;
          color: #999999;
        }
      }
    }
  }


  .order-list-wrap {
    width: 100%;

    .order-card {
      width: 100%;
      margin-top: 16px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
      border-radius: 2px;
      padding-bottom: 20px;

      .order-tab {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #CCD7DB;
        padding: 19px 25px 0 25px;
        box-sizing: border-box;

        .tabs {
          display: flex;
          align-items: center;
          column-gap: 40px;
          width: 100%;

          .item {
            font-size: 16px;
            font-weight: 400;
            color: #222222;
            padding-bottom: 11px;
            cursor: pointer;

            .num {
              color: #00B4E8 !important;
              margin-left: 5px;
            }
          }

          .active {
            color: #00B4E8 !important;
            border-bottom: 2px solid #00B4E8 !important;
          }
        }

        .order-manager {
          width: 70px;
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          padding-bottom: 11px;
          cursor: pointer;
        }

        .order-manager-active {
          color: #00B4E8 !important;
          border-bottom: 2px solid #00B4E8 !important;
        }
      }

      .order-content-wrap {
        width: 100%;
        box-sizing: border-box;
        padding: 0 27px;

        .data-type-wrap {
          display: flex;
          align-items: center;
          column-gap: 20px;

          .active {
            color: #FFFFFF !important;
            background: #00B4E8 !important;
          }

          .item {
            font-size: 16px;
            font-weight: 400;
            color: #00B4E8;
            background: #00b6e81a;
            padding: 7px 41px;
            cursor: pointer;
          }
        }

        .empty-tip {
          display: block;
          margin: 0 auto;
        }

        .search-bar {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 0;

          .search-inp-wrap {
            box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
            display: flex;
            align-items: center;

            .inp-wrap {
              width: 367px;
              height: 40px;
              padding: 0 22px;
              display: flex;
              align-items: center;

              &>input {
                width: 100%;
                border: none;
                outline: none;
                background-color: transparent;
              }
            }

            .search-btn {
              width: 65px;
              height: 40px;
              background: #6F7F84;
              box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .page-operate {
            display: flex;
            align-items: center;
            column-gap: 5px;

            .page-btn {
              padding: 8px 16px;
              font-size: 16px;
              font-weight: 400;
              color: #CCD7DB;
              width: 82px;
              background: #FFFFFF;
              border-radius: 2px;
              border: 1px solid #CCD7DB;
            }
          }
        }

        .table-header {
          width: 100%;
          padding: 7px 0;
          background: rgba(111, 127, 132, 0.102);
          display: grid;
          grid-template-columns: auto 120px 120px 120px 170px;
          font-size: 16px;
          font-weight: 400;
          color: #6F7F84;
          align-items: center;
          text-align: center;
          box-sizing: border-box;
        }
      }
    }
  }

}
</style>
